import React, {useState} from 'react'

const SelectRole = ({ setRole }) => {
  const [selectedRole, setSelectedRole] = useState(null);

  const showInvestmentPromptClick = () => {
    setRole('investment');
    setSelectedRole('investment')
  }

  const showBusinessPromptClick = () => {
    setRole('business');
    setSelectedRole('business')
  }
    
  return (
    <div className="select-role">
      <div className="prompt-msg"><i className="fa-regular fa-lightbulb"></i>知りたいことを選んでください</div>
      <div className="select-role-container">
        <button className={`role ${selectedRole != "investment" && selectedRole ? "unselected" : "selected" }`} data-value="for-investment" onClick={showInvestmentPromptClick}>投資向けの情報が知りたい</button>
        <button className={`role ${selectedRole != "business" && selectedRole ? "unselected" : "selected" }`} data-value="for-business" onClick={showBusinessPromptClick}>事業向けの情報が知りたい</button>
      </div>
    </div>
  )
}

export default SelectRole
